import { render, staticRenderFns } from "./MoleculeLogout.vue?vue&type=template&id=6d585a24"
import script from "./MoleculeLogout.vue?vue&type=script&lang=js"
export * from "./MoleculeLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports